import _merge from 'lodash/merge';

import Localization from '@web-solutions/module-localization';
import { initLocalization as initMS } from '@web-solutions/manage-subscription';
import i18next, { type Resource } from 'i18next';
import base from '@web-solutions/base-app/localization/en.json';

import { APP_NAME, SUPPORT_EMAIL } from 'src/constants/general';

import en from './en.json';
import cs from './cs.json';
import de from './de.json';
import es from './es.json';
import tr from './tr.json';
import fr from './fr.json';
import it from './it.json';
import id from './id.json';
import pt from './pt.json';
import getLocale from './get-locale';

const allLocales = {
  en,
  cs,
  de,
  es,
  tr,
  fr,
  it,
  id,
  pt,
};

export function initLocalization(activeLangs: string[]) {
  const resources: Resource = {};
  activeLangs.forEach((lang) => {
    if (allLocales[lang]) {
      resources[lang] = {
        translation: _merge({}, base, allLocales[lang]),
      };
    }
  });

  Localization.init(resources, { appName: APP_NAME, supportEmail: SUPPORT_EMAIL });

  const locale = getLocale();
  i18next.changeLanguage(locale);
}

// export function initLocalization() {
//   Localization.init(resources, { appName: APP_NAME, supportEmail: SUPPORT_EMAIL });
//   // initMS();
//   const locale = getLocale();
//   i18next.changeLanguage(locale);
// };

